import EditPartner from './EditPartner';
import ListPartners from './ListPartners';
import NewPartnerModal from './NewPartnerModal';
import ViewPartner from './ViewPartner';

window.Vue.component('EditPartner', EditPartner);
window.Vue.component('ListPartners', ListPartners);
window.Vue.component('NewPartnerModal', NewPartnerModal);
window.Vue.component('ViewPartner', ViewPartner);